import React from 'react';

import classNames from 'classnames/bind';
import style from './Mention.scss';
const ctx = classNames.bind(style);

const Mention = props => <div className={ctx('mension')}>{props.children}</div>;

export default Mention;
